// Generate a UUID to be used for scrape request, will be removed along with the scrape request
export const generateUuid = (): string => {
  // eslint-disable-next-line dot-notation
  const cryptoObj = window.crypto || window['msCrypto']; // for IE 11

  const uint32Array = cryptoObj.getRandomValues(new Uint32Array(4));

  return Array.from(uint32Array)
    .map((item: number) => item.toString(36))
    .join('-');
};

export const getRandomId = (): string => {
  return Math.random().toString(36).slice(2, 11);
};
